import { __decorate, __metadata } from "tslib";
import { Observable, Computed } from '../../Model/Decorators';
import PropertyInstance from '../../Model/PropertyInstance';
import RuleValidator from './RuleValidator';
import { ContainerValidationState } from '../ValidationState';
import PropertyValidator from './PropertyValidator';
import PropertyInfo from '../../Model/PropertyInfo';
import ValidationDisplayHelper from '../DisplayHelper';
import { NeoTypeInfo } from '../../Model/NeoTypeInfo';
var ModelValidator = /** @class */ (function () {
    function ModelValidator(model, objectRules) {
        var _this = this;
        this.model = model;
        // Properties that contain at least 1 rule.
        this.ruleProperties = [];
        // Rules which don't display on any properties.
        this.objectRules = [];
        // Rules belonging to properties, by ruleId.
        this.propertyRules = new Map();
        this.hasCheckedRules = false;
        this.forceShowErrors = false;
        if (objectRules.length) {
            var tempPropertyInstance_1 = new PropertyInstance(model, new PropertyInfo(""));
            objectRules.forEach(function (rule) {
                _this.objectRules.push(new RuleValidator(tempPropertyInstance_1, rule));
            });
        }
        NeoTypeInfo.makeObservable(this);
    }
    ModelValidator.prototype.addProperty = function (property) {
        this.ruleProperties.push(property);
    };
    /**
     * Creates a property validator from its list of Rules.
     * One RuleValidator will be created per rule, even if the rule is added to multiple properties.
     */
    ModelValidator.prototype.createPropertyValidator = function (property) {
        var ruleList = [];
        for (var _i = 0, _a = property.propertyInfo.rules; _i < _a.length; _i++) {
            var rule = _a[_i];
            var ruleValidator = this.propertyRules.get(rule.ruleId);
            if (!ruleValidator) {
                ruleValidator = new RuleValidator(property, rule);
                this.propertyRules.set(rule.ruleId, ruleValidator);
            }
            ruleValidator.properties.push(property);
            ruleList.push(ruleValidator);
        }
        return new PropertyValidator(property, ruleList);
    };
    Object.defineProperty(ModelValidator.prototype, "ruleState", {
        get: function () {
            this.checkRules();
            return this._ruleState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelValidator.prototype, "isValid", {
        get: function () {
            return this.ruleState.isValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelValidator.prototype, "severity", {
        get: function () {
            return this.ruleState.severity;
        },
        enumerable: false,
        configurable: true
    });
    ModelValidator.prototype.checkRules = function () {
        var _this = this;
        this._ruleState = new ContainerValidationState();
        this.objectRules.forEach(function (r) {
            _this._ruleState.merge(r.ruleContext);
        });
        // Make sure all property validators have been initialised
        if (!this.hasCheckedRules) {
            this.hasCheckedRules = true;
            this.ruleProperties.forEach(function (p) { return p.validator; });
        }
        this.propertyRules.forEach(function (v) {
            _this._ruleState.update(v.ruleContext);
        });
    };
    /**
     * Gets the broken rules for this object. If you need the summary for an object graph, use Validation.getValidationSummary()
     */
    ModelValidator.prototype.getBrokenRules = function () {
        var ruleState = this.ruleState;
        var objectInfo = this.objectRules.filter(function (v) { return v.ruleContext.hasDetail; }).map(function (v, index) {
            return {
                order: index,
                displayInfo: ValidationDisplayHelper.getDisplayInfo(v.ruleContext, true),
                properties: []
            };
        });
        var properties = Array.from(this.propertyRules.values()).filter(function (v) { return v.ruleContext.hasDetail; }).map(function (v, index) {
            return {
                order: index + 1000,
                displayInfo: ValidationDisplayHelper.getDisplayInfo(v.ruleContext, true),
                properties: v.properties
            };
        });
        return {
            model: this.model,
            isValid: ruleState.isValid,
            objectDisplayInfo: objectInfo,
            propertyRules: properties
        };
    };
    ModelValidator.prototype.getRuleResult = function (ruleDefinition) {
        if (ruleDefinition) {
            var rule = this.objectRules.find(function (c) { return c.ruleId === ruleDefinition.ruleId; });
            if (!rule) {
                rule = this.propertyRules.get(ruleDefinition.ruleId);
            }
            if (rule) {
                return rule.ruleContext;
            }
        }
        return null;
    };
    ModelValidator.prototype.resetDisplay = function () {
        this.forceShowErrors = false;
        this.ruleProperties.forEach(function (p) { return p.validator.hasBlurred = false; });
    };
    __decorate([
        Observable()
        /** True if errors must be shown for this object, even if the user hasnt tabbed off some properties */
        ,
        __metadata("design:type", Boolean)
    ], ModelValidator.prototype, "forceShowErrors", void 0);
    __decorate([
        Computed(),
        __metadata("design:type", ContainerValidationState),
        __metadata("design:paramtypes", [])
    ], ModelValidator.prototype, "ruleState", null);
    return ModelValidator;
}());
export default ModelValidator;
